import { useState, memo, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import sanityClient from '../../sanityClient';

// Memoize static components to avoid unnecessary re-renders
const SocialLinks = memo(() => (
  <>
    <ul className="footer-social desktop-footersocial">
      <li><Link to={"https://www.instagram.com/interia_uk/"} target="_blank" rel="noopener noreferrer">instagram</Link></li>
      <li><Link to={"https://in.pinterest.com/interia_uk/"} target="_blank" rel="noopener noreferrer">pinterest</Link></li>
      <li><Link to={"https://www.facebook.com/theinteria"} target="_blank" rel="noopener noreferrer">facebook</Link></li>
      <li><Link to={"https://www.linkedin.com/company/the-interia/"} target="_blank" rel="noopener noreferrer">linkedin</Link></li>
      <li><Link to={"https://www.youtube.com/channel/UCPsoEhI1R1FqsUzs32gtUxQ"} target="_blank" rel="noopener noreferrer">youtube</Link></li>
      <li><Link to={"https://www.behance.net/umeshkumar158"} target="_blank" rel="noopener noreferrer">behance</Link></li>
      <li><Link to={"https://www.houzz.com/professionals/interior-designers-and-decorators/the-interia-pfvwus-pf~1546607601"} target="_blank" rel="noopener noreferrer">houzz</Link></li>
    </ul>

    <ul className="footer-social mobile-footersocial">
      <li><Link to={"https://www.instagram.com/interia_uk/"} target="_blank" rel="noopener noreferrer">ig</Link></li>
      <li><Link to={"https://in.pinterest.com/interia_uk/"} target="_blank" rel="noopener noreferrer">pin</Link></li>
      <li><Link to={"https://www.facebook.com/theinteria"} target="_blank" rel="noopener noreferrer">fb</Link></li>
      <li><Link to={"https://www.linkedin.com/company/the-interia/"} target="_blank" rel="noopener noreferrer">li</Link></li>
      <li><Link to={"https://www.youtube.com/channel/UCPsoEhI1R1FqsUzs32gtUxQ"} target="_blank" rel="noopener noreferrer">yt</Link></li>
      <li><Link to={"https://www.behance.net/umeshkumar158"} target="_blank" rel="noopener noreferrer">be</Link></li>
      <li><Link to={"https://www.houzz.com/professionals/interior-designers-and-decorators/the-interia-pfvwus-pf~1546607601"} target="_blank" rel="noopener noreferrer">houzz</Link></li>
    </ul>
  </>
));

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const [loading,setLoading] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      alert("Please enter an email address.");
      return;
    }

    try {
      // Send the email and current date/time to Sanity
      await sanityClient.create({
        _type: 'subscribe',
        email,
        date: new Date().toISOString(), // Add the current date and time in ISO format
      });
      setIsSubmitted(true);
      navigate("/thankyou");
    } catch (error) {
      console.error('Error submitting the subscription:', error);
    }
    setEmail(''); // Reset the form
  };

  useEffect(() => {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1500);
      return () => clearTimeout(timer);
    }, []);

  if (loading) return null;

  return (
    <>
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">

            <div className="footer-links">
              <ul className="footlink-1">
                <li><Link to={"/"}>home</Link></li>
                <li><Link to={"/about-us"}>about</Link></li>
                <li><Link to={"/blogs"}>Blog</Link></li>
                <li><Link to={"/media"}>Media</Link></li>
                <li><Link to={"/faq"}>Faq</Link></li>
                <li><Link to={"/career"}>career</Link></li>
                <li><Link to={"/contact-us"}>Contact</Link></li>
              </ul>

              <ul className="footlink-2">
                <li><Link to={"/privacy-policy"}>Privacy Policy</Link></li>
                <li><Link to={"/terms-conditions"}>terms & conditions</Link></li>
              </ul>
            </div>

            <div className="footer-logo">
              <img loading='lazy' src="/assets/home/footer-logo.svg" className="img-responsive" alt="Logo" width={"100%"} height={"100%"}/>
              <div className='subscribe-form'>
                <p>Subscribe to our newsletter</p>
                <form onSubmit={handleSubmit}>
                  <div>
                    <input type="email" id="email" name="email" placeholder="Email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} required/>
                    <button type="submit" className="default-btn">submit<span></span></button>
                  </div>
                </form>
              </div>
            </div>

            {/* Memoized static social links */}
            <div className="social-copywrite">
            <SocialLinks />

            <ul className="footer-term">
              <li><Link to={"/privacy-policy"}>Privacy Policy</Link></li>
              <li><Link to={"/terms-conditions"}>terms & conditions</Link></li>
            </ul>

            <p>© 2025 UK Interia Pvt. Ltd. All rights reserved.</p>
          </div>
        </div>
      </div>
      </div>
    </footer>
    </>
  );
}

export default Footer;
